import { useOutletContext, useParams } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

import Modal from 'react-bootstrap/Modal'

import NewBusinessEntityForm from './NewBusinessEntityForm.jsx'

import { BusinessEntityType } from '../../../../utils/constants.js'

const NewBusinessEntityModal = function ({ showSignal, parentBusinessEntity, currencies, refetchBusinessEntity, errorSignal }) {

	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()
	const { beId } = useParams()

	const hideModal = function () {
		showSignal.value = false
	}

	const selectedBusinessEntityTypeSignal = useSignal(null)

	const businessEntityTypeStringComputed = useComputed(() => {
		switch (selectedBusinessEntityTypeSignal.value) {
			case BusinessEntityType.Merchant:
				return "Merchant"
			case BusinessEntityType.Organization:
				return "Organization"
			case BusinessEntityType.Reseller:
				return "Reseller"
			default:
				return "Business Entity"
		}
	})

	return (
		<>
			<Modal show={showSignal.value} onHide={hideModal}>
				<Modal.Header closeButton>New {businessEntityTypeStringComputed.value}</Modal.Header>
				<Modal.Body>
					{parentBusinessEntity && (
						<NewBusinessEntityForm
							parentBusinessEntity={parentBusinessEntity}
							cancelAddBE={hideModal}
							selectedBusinessEntityTypeSignal={selectedBusinessEntityTypeSignal}
							currencies={currencies}
							businessEntityTypeStringComputed={businessEntityTypeStringComputed}
							refetchBusinessEntity={refetchBusinessEntity}
							errorSignal={errorSignal}
						></NewBusinessEntityForm>
					)}
				</Modal.Body>
			</Modal>
		</>
	)
}
export default NewBusinessEntityModal